import { createContext, FC, useContext } from 'react';

import { IServiceFactory } from './serviceFactoryInterface';

const defaultFactory: IServiceFactory = new Proxy({} as IServiceFactory, {
  get(target, p, receiver) {
    return () => {};
  },
});

const DepsContext = createContext<IServiceFactory>(defaultFactory);

interface serviceProps {
  serviceFactory: IServiceFactory;
  children?: JSX.Element;
}

export function useAppServices(): IServiceFactory {
  return useContext(DepsContext);
}

export const DepsProvider: FC<serviceProps> = ({
  children,
  serviceFactory,
}) => (
  <DepsContext.Provider value={serviceFactory}>{children}</DepsContext.Provider>
);
